import { createReducer } from '@ngrx/store';
import {
  AuthResponse,
  AuthState,
  passwordResetCheckFailed,
  passwordResetCheckSuccess,
  passwordResetLinkFailed,
  passwordResetLinkSuccess,
  resendTokenSuccess,
  resetCheckRequest,
  resetLinkRequest,
  selectedCountryCode,
  verificationCodeFailed,
  verificationCodeRequest,
  verificationCodeSuccess,
  verificationFailed,
  verificationRequest,
  verificationSuccess,
  changePasswordRequest,
  changePasswordSuccess,
  changePasswordFailed,
} from './auth-actions';
import { on } from '@ngrx/store';
import { registeringFailed, registeringRequest, registeringSuccess } from './auth-actions';

const defaultLoginResponse: AuthResponse = {
  success: false,
  message: '',
  data: null,
  statusCode: 0,
};

const initialState: AuthState = {
  loading: false,
  message: '',
  response: defaultLoginResponse,
  countryCode: '',
};

export const authenticationReducer = createReducer(
  initialState,

  on(
    registeringRequest,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    verificationCodeRequest,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    verificationCodeSuccess,
    (state, { response }): AuthState => ({
      ...state,
      loading: false,
      response: response,
    })
  ),

  on(
    verificationCodeFailed,
    (state, { error }): AuthState => ({
      ...state,
      loading: false,
      response: error,
    })
  ),

  on(
    resetCheckRequest,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    resendTokenSuccess,
    (state, { response }): AuthState => ({
      ...state,
      loading: false,
      response: response,
    })
  ),

  on(
    passwordResetLinkSuccess,
    (state, { response }): AuthState => ({
      ...state,
      loading: false,
      response: response,
    })
  ),

  on(
    resetLinkRequest,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    registeringSuccess,
    (state, { response }): AuthState => ({
      ...state,
      loading: false,
      response: response,
    })
  ),

  on(
    registeringFailed,
    (state, { error }): AuthState => ({
      ...state,
      loading: false,
      response: error,
    })
  ),

  on(
    passwordResetCheckSuccess,
    (state, { response }): AuthState => ({
      ...state,
      loading: false,
      response: response,
    })
  ),

  on(
    passwordResetCheckFailed,
    (state, { error }): AuthState => ({
      ...state,
      loading: false,
      response: error,
    })
  ),

  on(
    passwordResetLinkFailed,
    (state, { error }): AuthState => ({
      ...state,
      loading: false,
      response: error,
    })
  ),

  on(
    verificationSuccess,
    (state, { response }): AuthState => ({
      ...state,
      loading: false,
      response: response,
    })
  ),

  on(
    verificationFailed,
    (state, { error }): AuthState => ({
      ...state,
      loading: false,
      response: error,
    })
  ),

  on(selectedCountryCode, (state, { uuid, countries }): AuthState => {
    const selected = countries.find((c) => c.uuid === uuid);

    return {
      ...state,
      countryCode: selected?.code?.toString() ?? '',
    };
  }),

  on(
    changePasswordRequest,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    changePasswordSuccess,
    (state, { response }): AuthState => ({
      ...state,
      loading: false,
      response: response,
    })
  ),

  on(
    changePasswordFailed,
    (state, { error }): AuthState => ({
      ...state,
      loading: false,
      response: error,
    })
  )
);
